export default __webpack_public_path__ + "static/media/MondelezLogo.41763ead.svg";